/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { signOut } from "../../actions/authActions";

const avatarStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: #fff;
  border-radius: 50%;
  color: #f7c02d;
  margin-left: 10px;
`;

const avatar_link_syle = css` 
    &::after {
       visibility: hidden;
    }
`;

function SignedInLink(props) {
  return (
    <Fragment>
      <li>
        <a href="##" onClick={props.signOut}>
          ВЫЙТИ
        </a>
      </li>
      <li>
        <Link to="/" css={avatar_link_syle}>
          <div css={avatarStyle}>{props.profile.initials}</div>
        </Link>
      </li>
    </Fragment>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    signOut: () => dispatch(signOut())
  };
};

export default connect(
  null,
  mapDispatchToProps
)(SignedInLink);
